module.exports = __webpack_public_path__ + "img/logoIcon.2acc3b52.png";